import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1b63c788&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b63c788",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b63c788')) {
      api.createRecord('1b63c788', component.options)
    } else {
      api.reload('1b63c788', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1b63c788&scoped=true&", function () {
      api.rerender('1b63c788', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ClientDashboard/overview/index.vue"
export default component.exports